import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export default function ApparMandatoryModal(props) {
    const {open }  = props
    const handleRedirect = ()=>{
        window.location.href = `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}`;

    }
    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600 }}>
                APAAR Authorization Required
            </DialogTitle>

            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{ fontSize: "16px", lineHeight: 1.6 }}
                >
                    Your APAAR ID is not authorized, and it has not been entered in the Profile section.
                    To continue, please click on <span style={{fontWeight : 600}}>"Redirect to Home"</span> and follow the steps below:
                    <ol>
                        <li>Go to the <span style={{fontWeight : 600}}>Profile</span> tab.</li>
                        <li>Click on <span style={{fontWeight : 600}}>"Click here to authorize APAAR ID"</span></li>
                        <li>Complete authorization through <span style={{fontWeight : 600}}>DigiLocker</span></li>
                        <li>Enter your <span style={{fontWeight : 600}}>16-digit APAAR ID</span></li>
                        <li>Click on <span style={{fontWeight : 600}}>"Save changes"</span></li>
                    </ol>
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ padding: "16px" }}>
                <Button
                    variant="contained"
                    onClick={handleRedirect}
                    color="primary"
                    autoFocus
                    sx={{ textTransform: "none" }}
                >
                    Redirect to Home
                </Button>
            </DialogActions>
        </Dialog>

    )
}